import React from 'react';
import { Helmet } from 'react-helmet';
import SEO from '../common/SEO';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import FormTwo from '../component/contact/FormTwo';
import WhatsAppButton from './WhatsAppButton';
import PhoneButton from './PhoneButton';


const Contact = () => {
    return (
        <>
            <Helmet>
                <title>اتصل بنا - كاتبي للحلول الرقمية</title>
                <meta name="description" content="تواصل معنا للحصول على مزيد من المعلومات حول خدماتنا. نحن هنا للمساعدة والإجابة على جميع استفساراتك." />
                <link rel="canonical" href="https://www.katbi.net/contact" />
            </Helmet>
            <SEO title="اتصل بنا" />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BreadCrumbOne 
                    title="اتصل بنا"
                    page="اتصل بنا"
                />
                <div className="section section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-5 col-lg-6">
                                <div className="contact-form-box shadow-box mb--30">
                                    <h3 className="title">احصل على عرض سعر</h3>
                                    <FormTwo />
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 offset-xl-1">
                                <div className="contact-info mb--100 mb_md--30 mt_md--0 mt--150">
                                    <h4 className="title">هاتف</h4>
                                    <p>متواجدون من الساعة العاشرة صباحاً وحتى السادسة مساءً</p>
                                    <h4 className="phone-number"><a href="tel:0505733543">543 5733 (050)</a></h4>
                                </div>
                                <div className="contact-info mb--30">
                                    <h4 className="title">بريد إلكتروني</h4>
                                    <p>يمكنك مراسلتي عبر البريد الإلكتروني</p>
                                    <h4 className="phone-number"><a href="mailto:support@katbi.net">support@katbi.net</a></h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul className="list-unstyled shape-group-12">
                        <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"} alt="Bubble" /></li>
                        <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"} alt="Bubble" /></li>
                        <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/circle-3.png"} alt="Circle" /></li>
                    </ul>
                </div>
                <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
                <WhatsAppButton />
                <PhoneButton />

            </main>
        </>
    );
}

export default Contact;
